import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { CheckCircle2, XCircle } from 'lucide-react';

export default function AdminToast({ toast, onClose }) {
  const open = Boolean(toast?.open);
  const isSuccess = toast?.type !== 'error';
  const duration = isSuccess ? 3200 : 4500;

  useEffect(() => {
    if (!open) return undefined;
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [open, toast?.id, onClose, duration]);

  if (!open) return null;

  const title = toast.title || (isSuccess ? '操作成功' : '操作失败');
  const detail = toast.message && toast.message !== title ? toast.message : '';

  return createPortal(
    <div
      className={`admin-toast admin-toast--${toast.type}`}
      role="status"
      aria-live="polite"
      onClick={onClose}
    >
      <span className="admin-toast__icon" aria-hidden="true">
        {isSuccess ? <CheckCircle2 size={16} strokeWidth={2.2} /> : <XCircle size={16} strokeWidth={2.2} />}
      </span>
      <div className="admin-toast__body">
        <div className="admin-toast__title">{title}</div>
        {detail ? <div className="admin-toast__detail">{detail}</div> : null}
      </div>
    </div>,
    document.body,
  );
}
